import { render, staticRenderFns } from "./ImageArea.vue?vue&type=template&id=0140bdeb&scoped=true"
import script from "./ImageArea.vue?vue&type=script&lang=ts"
export * from "./ImageArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0140bdeb",
  null
  
)

export default component.exports